import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import { GetStakingRiskProductUserInfoThunk } from "../../../Thunks/StakingRiskThunk";
import arrow from "../../../Assets/img/stakingrisk/arrow.svg";
import { formatStakingCurrency } from "../../../Utils/helper";
import SingleRiskDetails from "./singleRiskDetails";
import ColoredStatistics from "./coloredstatistic";
import ProductCard from "./productCard";
import styles from "../StakingRiskDetails/staking-risk.module.css";

export function StakingRiskRightDetails({ activeId, scrollY, containerRef }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [componentVisible, setComponentVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [vectorVisible, setVectorVisible] = useState(false);

  const stakingRiskProductInfo = useSelector((state) => { return state.StakingRiskReducer.stakingRiskProductInfo });

  useEffect(() => {
    dispatch(GetStakingRiskProductUserInfoThunk(location.state?.productId || activeId))

  }, [activeId, selectedProduct])

  useEffect(() => {
    if (scrollY)
      sessionStorage.setItem("stakingRiskScrollY", scrollY || sessionStorage.getItem("stakingRiskScrollY"));
  }, [scrollY])

  const selectedProducta = location.state?.selectedProduct;
  const rawClassifications = stakingRiskProductInfo?.stakingRisk?.stakingRiskClassifications || [];

  const sortedClassifications = [...rawClassifications].sort(
    (a, b) => (b.weightedScore || 0) - (a.weightedScore || 0)
  );

  // Step 2: Slice top 3 and the rest
  const topClassifications = sortedClassifications.slice(0, 3);
  const otherClassifications = sortedClassifications.slice(3);

  // Step 3: Format top classifications
  const formattedClassifications = topClassifications.map((item, index) => ({
    label: item.key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase()),
    value: Number((Number(item.weightedScore) || 0).toFixed(1)),
    width: ["340", "310", "210"][index],
    color: ["#4DC7B5", "#F5B452", "#F27281"][index] || "#ccc",
  }));

  // Step 4: Calculate sum of 'Other' values
  const otherScore = otherClassifications.reduce(
    (sum, item) => sum + Number(item.weightedScore || 0),
    0
  );

  // Step 5: Add "Other" category if necessary
  const weightedScoreStatisticData = [
    ...formattedClassifications,
    ...(otherScore > 0
      ? [{
        label: "Other",
        value: (Number(otherScore).toFixed(1)),
        width: ['190'],
        color: "#e5e5e7",
      }]
      : []),
  ];

  return (
    <>
      <section className={`sr-right-header ${styles["sr-right-header"]}`}>
        <div className={styles["sr-right-header-left"]}>
          {selectedProducta ? <div className={styles["arrow"]} onClick={() => {
            setSelectedProduct(null);
            navigate(`/staking-risk/details/${activeId}`, {
              state: { selectedProduct: null }
            });
            setTimeout(() => {
              const savedScroll = parseInt(sessionStorage.getItem("stakingRiskScrollY"), 10) || 0;
              if (containerRef.current) {
                containerRef.current.scroll({
                  top: savedScroll,
                  behavior: "smooth"
                });
              }
            }, 0);
          }}>
            <img src={arrow} alt="Arrow" />
          </div> :
            <div className={styles["arrow"]} onClick={() => {
              navigate("/staking-risk")
            }}>
              <img src={arrow} alt="Arrow" />
            </div>}
          <h2 className={styles.title}>
            <span> {stakingRiskProductInfo?.stakingRisk?.name}</span>
            {selectedProducta && ` / ${selectedProducta.name}`}
          </h2>
          <Tooltip
            placement="rightTop"
            title={
              stakingRiskProductInfo?.stakingRisk?.info ? (
                <div
                  style={{
                    maxHeight: "500px",
                    overflowY: "auto",
                    paddingRight: "6px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: stakingRiskProductInfo?.stakingRisk?.info,
                  }}
                />
              ) : null}
            color="#364048"
            open={vectorVisible}
            onOpenChange={setVectorVisible}
            overlayInnerStyle={{ width: "570px" }}>
            <div className="vector-circle">
              <i
                className="icon-Vector"
                style={{ fontSize: "19px", color: "#214175" }}
              />
            </div>
          </Tooltip>
          <Tooltip
            placement="rightTop"
            title={
              stakingRiskProductInfo?.stakingRisk?.recommendation ? (
                <div
                  style={{
                    maxHeight: "500px",
                    overflowY: "auto",
                    paddingRight: "6px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: stakingRiskProductInfo?.stakingRisk?.recommendation,
                  }}
                />
              ) : null
            }
            color="#364048"
            open={componentVisible}
            onOpenChange={setComponentVisible}
            overlayInnerStyle={{ width: "530px" }}
          >
            <span className="icon-Component-2">
              <span className="path1"></span>
              <span className="path2"></span>
            </span>
          </Tooltip>
        </div>
        {!selectedProducta && <div className={styles["sr-right-header-right"]}>
          <div className="card__price card__wallet__content">
            <div className="">
              <div
                className="card__wallet__rates"
                style={{
                  width: "200px",
                  display: "flex",
                  justifyContent: "space-between",
                }}>
                <span>Staked Amount</span>{" "}
                <span style={{ fontWeight: "bold", color: "#000" }}>{formatStakingCurrency(stakingRiskProductInfo?.stakedAmount)}</span>
              </div>
            </div>
          </div>
          <div
            className={styles.alert}
            style={{
              paddingTop: "15px",
              width: "90px",
              height: "64px",
              borderRadius: "64px",
              textAlign: "center",
            }}>
            <p className="card__risk__alert__title">Alert</p>
            <p className={"card__risk__alert__number"}>
              {stakingRiskProductInfo.alert === null || 0 ? 0 : stakingRiskProductInfo.alert}
            </p>
          </div>
        </div>}
      </section>
      {selectedProducta ? (
        <SingleRiskDetails selectedProduct={selectedProducta} activeId={activeId} />)
        : <>
          <div>
            <ColoredStatistics
              title="Weighted Risk:"
              data={weightedScoreStatisticData
              }
            />
          </div>
          <div>
            <ProductCard
              onSelect={(product) => setSelectedProduct(product)}
              product={stakingRiskProductInfo}
              activeId={selectedProduct} />
          </div>
        </>}
    </>
  );
}